import { render, staticRenderFns } from "./SampleDetails.vue?vue&type=template&id=e733454c"
import script from "./SampleDetails.vue?vue&type=script&lang=js"
export * from "./SampleDetails.vue?vue&type=script&lang=js"
import style0 from "./SampleDetails.vue?vue&type=style&index=0&id=e733454c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports